// extracted by css-extract-rspack-plugin
export default {"codeTag":"gORRVmQnMQckEO1n","codeText":"ssZuAUuruIsEErEf","inlineBlock":"JUrISHBhvzgcmV9I"};